import * as React from "react";

import { HashTag } from "./HashTag";
import { TagElement } from "@/interfaces";

import { removeWhiteSpace, useComplianceChecker } from "@/utils";

interface OwnProps {
  title: string;
  coachId: string | number;
  defaultHashtagList?: string;
  onError: (keywords: string[]) => void;
  onSuccess: (newTags: TagElement[]) => void;
  addHashtagOnChange?: (checked: boolean) => void;
  customTagStyle: string;
}

type Props = OwnProps;

export const HashTagSet: React.FC<Props> = ({ title, defaultHashtagList, coachId, onError, onSuccess }) => {
  const { blockedPhrases } = useComplianceChecker({ coachId });

  const hashTagsAsTags = (hashtagsString?: string): TagElement[] => {
    let hashtagsElements: TagElement[] = [];

    if (hashtagsString) {
      const hashtagsList = hashtagsString.split(" #");
      hashtagsElements = hashtagsList.map((hashtag, index) => {
        const tagElement: TagElement = {
          index,
          displayValue: removeWhiteSpace(hashtag.replace("#", "")),
          id: `${index}`,
        };
        return tagElement;
      });

      return hashtagsElements;
    }

    return hashtagsElements;
  };

  const [tagList, setTagList] = React.useState<TagElement[]>([]);

  React.useEffect(() => {
    setTagList(hashTagsAsTags(defaultHashtagList));
  }, [defaultHashtagList]);

  const validateNewInput = (newValues: TagElement[]): void => {
    onSuccess(newValues);
  };

  return (
    <div className="w-full" data-elm-id="projectHashtagsSet">
      <div className="w-full">
        <HashTag
          dataElmId="coachPromptHashtags"
          placeholder={title}
          tags={tagList}
          unavailableTags={blockedPhrases}
          onTagsChanged={validateNewInput}
          onInputRepeatedError={onError}
        />
      </div>
    </div>
  );
};
